module.exports = __webpack_public_path__ + "static/media/youtube.75392dc9.svg";